// extracted by mini-css-extract-plugin
export default {"customCloseButton":"CloseButton_customCloseButton__XLwLW","icon":"CloseButton_icon__fmnmL","defaultIcon":"CloseButton_defaultIcon__fLfRt","hoverIcon":"CloseButton_hoverIcon__zbQKi"};